// components/SmartAppDialog.tsx
import { Cross2Icon } from '@radix-ui/react-icons';
import { Dialog, Flex, Text, Button, Box, Heading } from '@radix-ui/themes';
import { useSmartAppDialog } from 'helpers/useSmartAppDialog';
import { AndroidIcon, AppleIcon, TennistalkerIcon } from './SocialIcons';

export const SmartAppDialog: React.FC = () => {
  const { isOpen, setIsOpen, deviceInfo } = useSmartAppDialog();

  // Don't render anything if there's no device info
  if (!deviceInfo) {
    return null;
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Content maxWidth='450px'>
        <div className='flex w-full justify-between align-middle'>
          <Dialog.Title>Scarica l'app di TennisTalker</Dialog.Title>
          <Dialog.Close className='mb-4 cursor-pointer'>
            <Cross2Icon height={'24'} width={'24'} />
          </Dialog.Close>
        </div>
        <Dialog.Description className='hidden'>
          Download the TennisTalker app for a better experience.
        </Dialog.Description>
        <Flex direction='column' gap='6' align='center' justify='center'>
          <Flex gap='4'>
            <TennistalkerIcon />
          </Flex>
          <Flex>
            <Box className='flex flex-col justify-center gap-4 text-center'>
              <Heading as='h5' size='4'>
                Vivi l'esperienza completa con la nostra App!
              </Heading>
              <Text as='p' size='2' color='gray'>
                Naviga tra giocatori, risultati, statistiche e molto altro con facilità.
              </Text>
              <Text as='p' size='4' weight='bold' mt='1'>
                Gratis - su {deviceInfo.storeName}
              </Text>
            </Box>
          </Flex>

          <Flex gap='3' mt='2' justify='end'>
            <Button size={'4'} asChild>
              <a href={deviceInfo.storeLink} target='_blank' rel='noopener noreferrer'>
                {deviceInfo.os === 'ios' ? <AppleIcon /> : <AndroidIcon />}
                <Text ml='2'>Scarica</Text>
              </a>
            </Button>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};
